import axios from 'axios';
import getDetails from '../../api/EnviromentConfig';
import type { Account } from '../../pages/PRM/Accounts/accountsTypes';
import { PRMConfig } from '../../pages/PRM/PRMConfig';
import { mockAccounts } from './PRMAccountsMockData';

const ACCOUNTS_ENDPOINT: string = '';

export async function getAccounts(): Promise<Account[]> {
  if (PRMConfig.useMockData) {
    return mockAccounts.map((account) => ({ ...account }));
  }

  if (!ACCOUNTS_ENDPOINT) {
    throw new Error('Accounts API is not configured.');
  }

  const { apiurl, subscriptionKey } = getDetails();
  const response = await axios<Account[]>({
    method: 'GET',
    url: `${apiurl}${ACCOUNTS_ENDPOINT}`,
    headers: {
      'Ocp-Apim-Subscription-Key': subscriptionKey,
    },
  });

  return response.data;
}
